import api from './api';

export const curriculumService = {
  // Get all curriculums with pagination and filters
  getCurriculums: async (params = {}) => {
    const response = await api.get('/admin/curriculums', { params });
    return response.data;
  },

  // Get single curriculum
  getCurriculum: async (id) => {
    const response = await api.get(`/admin/curriculums/${id}`);
    return response.data;
  },

  // Create new curriculum
  createCurriculum: async (curriculumData) => {
    const response = await api.post('/admin/curriculums', curriculumData);
    return response.data;
  },

  // Update curriculum
  updateCurriculum: async (id, curriculumData) => {
    const response = await api.put(`/admin/curriculums/${id}`, curriculumData);
    return response.data;
  },

  // Delete curriculum
  deleteCurriculum: async (id) => {
    const response = await api.delete(`/admin/curriculums/${id}`);
    return response.data;
  },

  // Add classes to curriculum
  addClasses: async (id, classesData) => {
    const response = await api.post(`/admin/curriculums/${id}/classes`, classesData);
    return response.data;
  },

  // Reorder classes in curriculum
  reorderClasses: async (id, orderData) => {
    const response = await api.post(`/admin/curriculums/${id}/reorder`, orderData);
    return response.data;
  },

  // Remove class from curriculum
  removeClass: async (id, classData) => {
    const response = await api.post(`/admin/curriculums/${id}/remove-class`, classData);
    return response.data;
  },

  // Preview curriculum
  previewCurriculum: async (id) => {
    const response = await api.get(`/admin/curriculums/${id}/preview`);
    return response.data;
  },

  // Set as default curriculum
  setDefault: async (id) => {
    const response = await api.post(`/admin/curriculums/${id}/set-default`);
    return response.data;
  },

  // Get curriculum statistics
  getStats: async () => {
    const response = await api.get('/admin/curriculums/stats');
    return response.data;
  },

  // Get available classes
  getAvailableClasses: async () => {
    const response = await api.get('/admin/curriculums/available-classes');
    return response.data;
  }
};